import React from 'react';

const EditIcon = ({width=490 , height=490}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18">
    <path fill="#293840" fillRule="evenodd" d="M12.848 1.173c1.095-1.096 2.879-1.097 3.976-.004.532.53.825 1.235.826 1.985 0 .682-.241 1.327-.684 1.837l-.138.15L6.109 15.882c-.313.313-.69.562-1.1.729l-.207.076-.046.014-4.455.996 1.014-4.45.01-.03c.14-.42.364-.81.655-1.143l.151-.16L12.848 1.172zM2.803 14.047l-.245 1.074.332.331 1.078-.241-1.165-1.164zm11.3-11.817l-.102.092-.284.284.986.983v.213l-.94.938h-.212l-.984-.982-.799.801.982.98v.212l-.94.939h-.212l-.98-.978-6.916 6.932 1.672 1.67 10.3-10.323c.192-.192.31-.437.34-.702l.007-.134c0-.316-.124-.611-.348-.834-.395-.394-1.003-.45-1.459-.168l-.11.077z"/>
  </svg>
);

export default EditIcon;
